var GMapResponsiveMarkers, SVG_INLINE;

SVG_INLINE = require('../../frontend/svgs');

module.exports = GMapResponsiveMarkers = (function() {
  function GMapResponsiveMarkers(googleMaps) {
    this.googleMaps = googleMaps;
  }

  GMapResponsiveMarkers.prototype.makeSVGString = function(type, text) {
    return "data:image/svg+xml;utf-8," + encodeURIComponent(SVG_INLINE[type].split('MARKER_LABEL_PLACEHOLDER').join(text));
  };

  GMapResponsiveMarkers.prototype.makeMarkers = function(markerData) {
    var baseMarkerOptions, defaultMarker, defaultMarkerOptions, i, isGroupon, len, marker, results, selectedMarker, selectedMarkerOptions, userMarker, userMarkerOptions;
    this.activeMarkers = [];
    this.nearbyLocationsCount = 0;
    results = [];
    for (i = 0, len = markerData.length; i < len; i++) {
      marker = markerData[i];
      if (marker.isNearbyLocation != null) {
        this.nearbyLocationsCount = this.nearbyLocationsCount + marker.isNearbyLocation;
      }
      baseMarkerOptions = {
        optimized: false,
        position: new this.googleMaps.LatLng(marker.lat, marker.lng)
      };
      if (marker.label.type === "USER") {
        userMarkerOptions = _.extend(baseMarkerOptions, {
          icon: {
            url: this.makeSVGString("USER", marker.label.text)
          }
        });
        userMarker = new this.googleMaps.Marker(userMarkerOptions);
        results.push(this.activeMarkers.push(userMarker));
      } else {
        isGroupon = !$('body').hasClass('brand-gemini') && !$('body').hasClass('brand-livingsocial');
        defaultMarkerOptions = _.extend(baseMarkerOptions, {
          icon: {
            url: isGroupon ? this.makeSVGString("DEFAULT", marker.label.text) : this.makeSVGString("DEFAULT_LS", marker.label.text)
          },
          zIndex: 1
        });
        defaultMarker = new this.googleMaps.Marker(defaultMarkerOptions);
        this.activeMarkers.push(defaultMarker);
        selectedMarkerOptions = _.extend(baseMarkerOptions, {
          icon: {
            url: isGroupon ? this.makeSVGString("SELECTED", marker.label.text) : this.makeSVGString("SELECTED_LS", marker.label.text)
          },
          zIndex: marker.label.type === "SELECTED" || marker.label.type === "SELECTED_LS" ? 2 : 0
        });
        selectedMarker = new this.googleMaps.Marker(selectedMarkerOptions);
        results.push(this.activeMarkers.push(selectedMarker));
      }
    }
    return results;
  };

  GMapResponsiveMarkers.prototype.addMarkersToMap = function(map) {
    var firstMarkerPosition, i, len, marker, ref;
    ref = this.activeMarkers;
    for (i = 0, len = ref.length; i < len; i++) {
      marker = ref[i];
      marker.setMap(map);
    }
    firstMarkerPosition = this.activeMarkers[0].getPosition();
    return map.setCenter(firstMarkerPosition);
  };

  GMapResponsiveMarkers.prototype.updateIcon = function(index, svgType) {
    var realIndex, ref;
    realIndex = this.getRealIndex(index);
    return (ref = this.activeMarkers[realIndex]) != null ? ref.setZIndex(svgType === "SELECTED" ? 2 : 0) : void 0;
  };

  GMapResponsiveMarkers.prototype.getRealIndex = function(index) {
    var realIndex;
    return realIndex = index * 2 + 1;
  };

  return GMapResponsiveMarkers;

})();

//# sourceMappingURL=data:application/json;base64,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
